/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';

import Empty from 'components/empty/Empty';
import StringResources from 'nls/StringResources';

import { PROFILE_PROPERTIES } from 'features/properties/ExploreLayoutPropertiesProvider';
import PropertiesPanel from './PropertiesPanel';

class PropertiesContainer extends Component {

	render() {
		const { widgetId, widgetType, dashboardApi, isDisplayed } = this.props;

		if (PROFILE_PROPERTIES.types.indexOf(widgetType) === -1) {
			// empty container for widgets with no available properties
			return (
				<div className="card-layout-content__side-panel__empty-container">
					<Empty
						type={'default'}
						alignment={'left'}
						title={StringResources.get('properties_panel_no_props_title')}
						description={StringResources.get('properties_panel_no_props_description')}
					/>
				</div>
			);
		} else {
			return (
				<PropertiesPanel
					widgetId={widgetId}
					widgetType={widgetType}
					dashboardApi={dashboardApi}
					isDisplayed={isDisplayed}
				/>
			);
		}
	}
}

PropertiesContainer.propTypes = {
	dashboardApi: PropTypes.object.isRequired,
	widgetId: PropTypes.string.isRequired,
	widgetType: PropTypes.string.isRequired,
	isDisplayed: PropTypes.boolean
};

export default PropertiesContainer;



// WEBPACK FOOTER //
// ./src/js/components/properties/PropertiesContainer.js